import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { LayoutWidthOptions, RatioOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NCmsRange {
    export interface IComponentData extends NICmsContentComponent.IData {
        width?: string;
        ratio: string;
        style: 'top' | 'bottom';
        items: IItem[];
    }

    export interface IItem {
        title?: string;
        title2?: string;
        subtitle?: string;
        link?: string;
        image: string;
        label?: string;
    }
}
@Component({
    selector: 'cms-range',
    templateUrl: 'cms-range.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [GridModule, CommonModule, SizeClassDirective, ImageModule, HrefComponent, ICmsClientModule]
})
@ICmsComponent<CmsRangeComponent>({
    id: 'range',
    name: 'Range',
    // image: '/common/cms/hero-image-component.png',
    description: 'Range grid',
    tags: ['category', 'range', 'grid'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'width',
            type: NICmsContentField.EFieldType.choice,
            title: 'Content Width',
            itemName: 'width',
            options: LayoutWidthOptions,
            default: 'wrap'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-1-1',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Style',
            options: [
                { key: 'top', title: 'Top' },
                { key: 'bottom', title: 'Bottom' }
            ],
            default: 'top'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'items',
            title: 'Items',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Item',
            itemNameField: 'title',
            defaultSize: 1,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title2',
                    title: 'Title 2'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'subtitle',
                    title: 'Subtitle'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link'
                },
                {
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    required: true
                },
                {
                    key: 'label',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Label'
                }
            ]
        }
    ]
})
export class CmsRangeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsRange.IComponentData;

    get isTop(): boolean {
        return this.component.style === 'top';
    }
}
